export default __webpack_public_path__ + "static/media/medical-interior-1.5a1a0e0e.jpg";